import {ChecklistModelItemQuestion} from './checklistModelItemQuestion.model';

export class ChecklistQuestionAnswer {
    id: number;
    value: string;
    answerDate: string;
    note: string;
    checklistAnswerId: number;
    checklistModelItemQuestion: ChecklistModelItemQuestion;

    constructor(checklistQuestionAnswer: any) {
        if (checklistQuestionAnswer) {
            this.id = checklistQuestionAnswer.id;
            this.value = checklistQuestionAnswer.value;
            this.answerDate = checklistQuestionAnswer.answerDate;
            this.note = checklistQuestionAnswer.note;
            this.checklistAnswerId = checklistQuestionAnswer.checklistAnswerId;
            this.checklistModelItemQuestion = new ChecklistModelItemQuestion(checklistQuestionAnswer.checklistModelItemQuestion);
        }
    }
}
